// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SOG2dPpsAGh4SWJkfJ63R","IconTrailing":"kwqBVmGnh72bcqU0jflQq","Title":"go8oasgYl35EyQfNaIL39","Name":"_1BXUHZFdTSXWVhXJK-nje7","Button":"_10kURoZIKYCEZbuPIsBiYG","DownloadAlert":"_1WJyiFGUb-HKiJRioOrM38"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/Title/styles.css
// module id = 3017
// module chunks = 0